export const API_ERROR = 'API_ERROR'
export const CONCEAL = 'CONCEAL'
export const HIDE_PITCH_SECTION = 'HIDE_PITCH_SECTION'
export const PUBLISH = 'PUBLISH'
export const REMOVE_PITCH_SECTION = 'REMOVE_PITCH_SECTION'
export const SET_STARTUP_ATTR = 'SET_STARTUP_ATTR'
export const SET_STARTUP_DATA = 'SET_STARTUP_DATA'
export const SHOW_PITCH_SECTION = 'SHOW_PITCH_SECTION'
export const START_FETCH = 'START_FETCH'
export const START_FOLLOWING = 'START_FOLLOWING'
export const START_SAVE = 'START_SAVE'
export const STOP_FETCH = 'STOP_FETCH'
export const STOP_FOLLOWING = 'STOP_FOLLOWING'
export const STOP_SAVE = 'STOP_SAVE'
